import React from "react";
import { HeaderModule } from "../../components/home/HeaderModule";
import { DeleteOutline } from "@mui/icons-material";
import { ActionsBar } from "../../components/ActionsBar";
import { TableModule } from "../../components/home/TableModule";
import { useInactiveAssets } from "../../hooks/activos/useInactiveAssets";
// import { useAssets } from "../../hooks/activos/useAssets";

export const InactiveAssets = () => {

    const { columns, assets, searchAsset } = useInactiveAssets();

	return (
        <>
            <HeaderModule
                icon={ <DeleteOutline htmlColor="rgba(0, 0, 0, .6)" /> }
                title='In-Activos'
            />

            <ActionsBar
                module='inactivos' 
                searchAction={ searchAsset } 
                searchPlaceholder='Placa'
            />    

            <TableModule
                columns={ columns }
                rows={ assets }
                styles={{
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10,
                }}
            />      
        </>
    )
}